import Swiper, {Navigation, Pagination} from 'swiper';
Swiper.use([Navigation, Pagination]);

const initTeachersSlider = () => {
   const sliderContainer = document.querySelector('.teachers__slider');
   sliderContainer && new Swiper(sliderContainer, {
      watchOverflow: true,
      effect: 'slide',
      breakpoints: {
         1170: {
            slidesPerView: 4,
            spaceBetween: 20,
         },
         768: {
            slidesPerView: 3,
            spaceBetween: 15,
         },
         500: {
            slidesPerView: 2,
            spaceBetween: 15,
         },
         0: {
            slidesPerView: 1.2,
            spaceBetween: 10,
         },
      },
      navigation: {
         nextEl: ".teachers .slider-navigation__button--next",
         prevEl: ".teachers .slider-navigation__button--prev",
      },
      pagination: {
         el: ".teachers .swiper-pagination",
         type: "fraction",
      },
      a11y: {
         enabled: true,
         prevSlideMessage: 'Переход на предыдущий слайд',
         nextSlideMessage: 'Переход на следующий слайд',
      },
   });
};

export default initTeachersSlider;
